import React, { useEffect, useState } from "react";
import { Button, Col, Row, Form } from "react-bootstrap";
import {
  Card,
  CardBody,
  CardHeader,
} from "../../../_metronic/_partials/controls";
import { LayoutSplashScreen } from "../../../_metronic/layout";
import { QahoTable } from "./QahoTable";
import { useSelector, useDispatch } from "react-redux";
import {
  resetData,
  selectData,
  selectLoading,
  selectPageNo,
  selectPageSize,
  selectTotalRecord,
  fetchAll,
} from "./qahoSlice";
import { useParams } from "react-router-dom";

export const QahoPage = (params) => {
  const dispatch = useDispatch();
  const data = useSelector(selectData);
  const loading = useSelector(selectLoading);
  const pageNo = useSelector(selectPageNo);
  const pageSize = useSelector(selectPageSize);
  const totalRecord = useSelector(selectTotalRecord);

  // Filter
  const [retNumber, setRetNumber] = useState("");
  const [invoiceNo, setInvoiceNo] = useState("");
  const [clientName, setClientName] = useState("");
  const [customerName, setCustomerName] = useState("");

  const { id } = useParams();

  useEffect(() => {
    // Reset on first load
    dispatch(resetData());
  }, [dispatch]);

  useEffect(() => {
    if (id != null) {
      dispatch(
        fetchAll({
          stepCode: "QAHO",
          retNumber: id,
          pageNo: pageNo,
          pageSize: pageSize,
        })
      );
    }
  }, [id]);

  const handleSearch = () => {
    const params = {
      stepCode: "QAHO",
      retNumber: retNumber.replace(/\s/g, ""),
      invoiceNo: invoiceNo,
      clientName: clientName,
      customerName: customerName,
      pageNo: 1,
      pageSize: 10,
    };
    dispatch(fetchAll(params));
  };

  const handleTableChange = (type, { page, sizePerPage }) => {
    const params = {
      stepCode: "QAHO",
      retNumber: retNumber.replace(/\s/g, ""),
      invoiceNo: invoiceNo,
      clientName: clientName,
      customerName: customerName,
      pageNo: page,
      pageSize: sizePerPage,
    };
    dispatch(fetchAll(params));
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      handleSearch();
    }
  };

  return loading ? (
    <LayoutSplashScreen />
  ) : (
    <Card>
      <CardHeader title="QAHO"></CardHeader>
      <CardBody>
        {/* Filter */}
        <Form>
          <Form.Group as={Row}>
            <Col sm={6}>
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>APL Return Number </b>
                </Form.Label>
                <Col sm={5}>
                  <Form.Control
                    type="text"
                    placeholder="APL Return Number "
                    onChange={(e) => {
                      setRetNumber(e.target.value);
                    }}
                    value={retNumber}
                    onKeyPress={handleKeyPress}
                  />
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>Invoice Ref Num</b>
                </Form.Label>
                <Col sm={5}>
                  <Form.Control
                    type="text"
                    placeholder="Invoice No"
                    onChange={(e) => {
                      setInvoiceNo(e.target.value);
                    }}
                    onKeyPress={handleKeyPress}
                    value={invoiceNo}
                  />
                </Col>
              </Form.Group>
            </Col>

            {/* Right Row */}
            <Col sm={6}>
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>Customer Name</b>
                </Form.Label>
                <Col sm={5}>
                  <Form.Control
                    type="text"
                    placeholder="Customer Name"
                    onChange={(e) => {
                      setCustomerName(e.target.value);
                    }}
                    value={customerName}
                    onKeyPress={handleKeyPress}
                  />
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>Client Name</b>
                </Form.Label>
                <Col sm={5}>
                  <Form.Control
                    type="text"
                    placeholder="Client Name"
                    onChange={(e) => {
                      setClientName(e.target.value);
                    }}
                    value={clientName}
                    onKeyPress={handleKeyPress}
                  />
                </Col>
              </Form.Group>
            </Col>
            <Form.Group as={Row}>
              <Col sm={6}>
                <Button className="btn btn-primary" onClick={handleSearch}>
                  Search
                </Button>
              </Col>
            </Form.Group>
          </Form.Group>
        </Form>

        {/* Table */}
        {data && data.length > 0 && (
          <QahoTable
            data={data}
            page={pageNo}
            sizePerPage={pageSize}
            totalSize={totalRecord}
            onTableChange={handleTableChange}
            loading={loading}
          />
        )}
      </CardBody>
    </Card>
  );
};
